/**
 * Theme-aware color palette used in inline styles across the app.
 *
 * Each value points at a CSS custom property whose concrete color is set at
 * runtime from `themeColors.ts` (see themeModeContext). Because these are
 * `var(--token)` references, every component that reads `palette.*` switches
 * between dark and light automatically — no per-component changes needed.
 *
 * Concrete values & the light/dark maps live in ./themeColors.ts.
 */
export const palette = {
  // Backgrounds
  bgApp: 'var(--bg-app)',
  bgPrimary: 'var(--bg-primary)',
  bgSurface: 'var(--bg-surface)',
  bgElevated: 'var(--bg-elevated)',
  bgDark: 'var(--bg-dark)',
  bgTableAlt: 'var(--bg-table-alt)',

  // Primary accent — gold
  accent: 'var(--accent)',
  accentDark: 'var(--accent-dark)',
  accentText: 'var(--accent-text)',

  // Secondary accent — teal
  teal: 'var(--teal)',
  tealText: 'var(--teal-text)',

  // Text
  textPrimary: 'var(--text-primary)',
  textSecondary: 'var(--text-secondary)',
  textMuted: 'var(--text-muted)',
  textDark: 'var(--text-dark)',

  // Bet outcomes
  betWrong: 'var(--bet-wrong)',
  betCorrect: 'var(--bet-correct)',
  betPerfect: 'var(--bet-perfect)',

  // Actions / misc
  link: 'var(--link)',
  successAccept: 'var(--success-accept)',
  errorReject: 'var(--error-reject)',
  border: 'var(--border)',
  hoverBorder: 'var(--hover-border)',
} as const;
